import { Theme } from "best-common-react";

const userMgmtTheme = {
  ...Theme
  // override/add app-specific theme values here
};

export default userMgmtTheme;
